
import { Observable } from './druid/./druid/Observable';
import { take } from './druid/./druid/operator/take';

Observable.prototype.take = take;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    take: typeof take;
  }
}